import createIcon from "../create-icon";

export const CheckIcon = createIcon("Check", [
  ["polyline", { points: "20 6 9 17 4 12", key: "10jjfj" }],
]);
